(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[11245,598],{

/***/ 98652:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stream",
      function () {
        return __webpack_require__(1067);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 1067:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ stream; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/global/MainLayout/index.tsx + 4 modules
var MainLayout = __webpack_require__(53120);
// EXTERNAL MODULE: ./src/global/Loading/PageLoader.jsx + 2 modules
var PageLoader = __webpack_require__(598);
// EXTERNAL MODULE: ./src/hooks/useProtectedRoute.js
var useProtectedRoute = __webpack_require__(56198);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Text.js
var Text = __webpack_require__(95541);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Button.js
var Button = __webpack_require__(20539);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Modal.js
var Modal = __webpack_require__(16368);
// EXTERNAL MODULE: ./src/@deprecated-ui/_style/color.js
var color = __webpack_require__(22147);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 17 modules
var es = __webpack_require__(2497);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
// EXTERNAL MODULE: ./src/global/Image/index.js
var Image = __webpack_require__(579);
// EXTERNAL MODULE: ./src/lib/entities/profile.js + 2 modules
var profile = __webpack_require__(333);
// EXTERNAL MODULE: ./src/features/paywall/analytics.ts
var analytics = __webpack_require__(67857);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./src/features/shop-revamp/components/SuccessSubscribeModal/styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b95f8445-0"
})(_templateObject());


;// CONCATENATED MODULE: ./src/features/shop-revamp/components/SuccessSubscribeModal/index.tsx












function SuccessSubscribeModal(param) {
    var visible = param.visible, onOk = param.onOk;
    var ref = (0,react.useState)(null), duration = ref[0], setDuration = ref[1];
    var proExpiry = (0,es/* useSelector */.v9)(profile/* proExpirySelector */.Cr);
    var expiredAt = moment_default()(proExpiry).format("D MMMM YYYY");
    (0,react.useEffect)(function() {
        if (!window || !window.localStorage) {
            return function() {};
        }
        setDuration(localStorage.getItem("plan-duration") || "");
        return function() {
            localStorage.removeItem("plan-duration");
        };
    }, []);
    var handleConfirmSuccess = function() {
        if (onOk) onOk();
        analytics/* default.onClickSuccessSubscribe */.ZP.onClickSuccessSubscribe();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
        width: "375px",
        centered: true,
        visible: visible,
        onCancel: onOk,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                    src: "/icon/success-subscribe.svg",
                    width: "160px",
                    height: "120px",
                    alt: "Success Subscribe"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    size: "18px",
                    family: "bold",
                    mb: "12px",
                    mt: "24px",
                    children: "Berhasil Berlangganan"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    size: "14px",
                    height: "21px",
                    children: "Masa aktif Stockbit PRO akan berlangsung selama"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                    size: "14px",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                            children: duration
                        }),
                        " dan akan berakhir pada",
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                            children: expiredAt
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    type: "primary",
                    width: "100%",
                    height: "44px",
                    // @ts-expect-error
                    mt: "32px",
                    onClick: handleConfirmSuccess,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        family: "bold",
                        color: color/* default.light */.Z.light,
                        children: "Oke"
                    })
                })
            ]
        })
    });
}
/* harmony default export */ var components_SuccessSubscribeModal = (SuccessSubscribeModal);

// EXTERNAL MODULE: ./src/global/MainLayout/slice.js
var slice = __webpack_require__(48153);
;// CONCATENATED MODULE: ./pages/stream/index.tsx

__webpack_require__(14473);








var Stream = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(97570), __webpack_require__.e(60296), __webpack_require__.e(88069), __webpack_require__.e(50299), __webpack_require__.e(92961), __webpack_require__.e(58928), __webpack_require__.e(92077), __webpack_require__.e(79931), __webpack_require__.e(42298), __webpack_require__.e(33082), __webpack_require__.e(35851), __webpack_require__.e(23304), __webpack_require__.e(63828), __webpack_require__.e(51767), __webpack_require__.e(45580), __webpack_require__.e(1013), __webpack_require__.e(97081), __webpack_require__.e(37713), __webpack_require__.e(57333), __webpack_require__.e(5406), __webpack_require__.e(46066), __webpack_require__.e(51402), __webpack_require__.e(54392), __webpack_require__.e(75413), __webpack_require__.e(71682), __webpack_require__.e(12683), __webpack_require__.e(66933), __webpack_require__.e(41232), __webpack_require__.e(91727), __webpack_require__.e(21066), __webpack_require__.e(14467), __webpack_require__.e(42293), __webpack_require__.e(54322)]).then(__webpack_require__.bind(__webpack_require__, 65910));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(65910)
            ];
        }
    },
    ssr: false
});
function StreamPage(props) {
    var showSuccessSubscribe = props.showSuccessSubscribe;
    var ref = (0,react.useState)(showSuccessSubscribe), showModal = ref[0], setShowModal = ref[1];
    var isLoaded = (0,useProtectedRoute/* default */.Z)().isLoaded;
    var isSideWidgetOpen = (0,es/* useSelector */.v9)(slice/* selectors */.wl).isSideWidgetOpen;
    var handleSubSuccessModalOK = function() {
        setShowModal(false);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MainLayout["default"], {
        maxWidth: isSideWidgetOpen ? 970 : 1037,
        isFlexibleWidth: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageLoader["default"], {
                loaded: isLoaded
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stream, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_SuccessSubscribeModal, {
                visible: showModal,
                onOk: handleSubSuccessModalOK
            })
        ]
    });
}
var __N_SSP = true;
/* harmony default export */ var stream = (StreamPage);


/***/ }),

/***/ 67857:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Lb": function() { return /* binding */ SideWidgetAnalytics; },
/* harmony export */   "Os": function() { return /* binding */ CompanyAnalytics; },
/* harmony export */   "oF": function() { return /* binding */ PageAnalytics; },
/* harmony export */   "wB": function() { return /* binding */ CompanyWidgetAnalytics; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26042);
/* harmony import */ var utils_clevertap__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48028);
/* eslint-disable no-shadow */ 

var PAYWALL = "Paywall Action";
var ACTION = {
    openAccess: "Paywall Open Access Selected",
    extendSubscribe: "Paywall Extend Subscribe Selected",
    openSecurities: "Paywall Open Securities Selected",
    openSubscribe: "Paywall Subscribe Selected",
    paymentSelected: "Paywall Payment Method Selected",
    inputVoucher: "Paywall Input Voucher Selected",
    confirmPayment: "Paywall Payment Confirmation  Selected",
    selectPlan: "Paywall Subscribe Plan Selected",
    confirmSubscribe: "Paywall Subscribe Confirmation Selected",
    submitVoucher: "Paywall Submit Voucher Selected",
    successSubscribe: "Paywall Subscribe Success Selected"
};
var SideWidgetAnalytics;
(function(SideWidgetAnalytics) {
    SideWidgetAnalytics["PRICE_ALERT"] = "Price Alert (Side Bar)";
    SideWidgetAnalytics["RUNNING_TRADE"] = "Running Trade (Side Bar)";
    SideWidgetAnalytics["VALUATION"] = "Valuation (Side Bar)";
    SideWidgetAnalytics["SCREENER"] = "Screener (Side Bar)";
    SideWidgetAnalytics["BANDAR_DETECTOR"] = "Bandar Detector (Side Bar)";
})(SideWidgetAnalytics || (SideWidgetAnalytics = {}));
var PageAnalytics;
(function(PageAnalytics) {
    PageAnalytics["ORDERBOOK"] = "Orderbook (Top Bar)";
    PageAnalytics["SCREENER"] = "Screener (Top Bar)";
    PageAnalytics["VALUATION"] = "Valuation (Top Bar)";
    PageAnalytics["CALENDAR"] = "Calendar (Top Bar)";
    PageAnalytics["EARNINGS"] = "Earnings (Top Bar)";
    PageAnalytics["CHARTBIT"] = "Chartbit (Top Bar)";
})(PageAnalytics || (PageAnalytics = {}));
var CompanyAnalytics;
(function(CompanyAnalytics) {
    CompanyAnalytics["ORDERBOOK"] = "Orderbook (Company)";
    CompanyAnalytics["RUNNING_TRADE"] = "Running Trade (Company)";
    CompanyAnalytics["KEYSTATS"] = "Keystats (Company)";
    CompanyAnalytics["ANALYST"] = "Analysis (Company)";
    CompanyAnalytics["FINANCIALS"] = "Financials (Company)";
    CompanyAnalytics["FUNDACHART"] = "Fundachart (Company)";
    CompanyAnalytics["SEASONALITY"] = "Seasonality (Company)";
    CompanyAnalytics["CHARTBIT"] = "Chartbit (Company)";
    CompanyAnalytics["COMPARISON"] = "Comparison (Company)";
    CompanyAnalytics["INSIDER"] = "Insider (Company)";
    CompanyAnalytics["PROFILE"] = "Company Profile (Company)";
    CompanyAnalytics["CORPACTION"] = "Corporate Action (Company)";
})(CompanyAnalytics || (CompanyAnalytics = {}));
var CompanyWidgetAnalytics = {
    Orderbook: "Orderbook (Company)",
    "Running Trade": "Running Trade (Company)",
    "Trade Book": "Trade Book (Company)",
    "Broker Summary": "Broker Summary (Company)"
};
var PaymentMethod;
(function(PaymentMethod) {
    PaymentMethod["bca_va"] = "BCA";
    PaymentMethod["veritrans"] = "Credit Card";
    PaymentMethod["gopay"] = "Gopay";
})(PaymentMethod || (PaymentMethod = {}));
function formatDuration(durationString) {
    var duration = parseInt(durationString, 10);
    if (Number.isNaN(duration)) {
        return durationString;
    }
    if (durationString.includes("MONTH")) {
        return "".concat(duration, " Bulan");
    }
    if (durationString.includes("YEAR")) {
        return "".concat(duration, " Tahun");
    }
    if (durationString.includes("DAY")) {
        return "".concat(duration, " Hari");
    }
    return durationString;
}
var createPaywallEvent = function(action, params) {
    var oldStatus = params.oldStatus, source = params.source, companyID = params.companyID;
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(PAYWALL, {
        Action: action,
        "Old Subscriber Pro": oldStatus,
        Source: source,
        "Company ID": companyID
    });
};
var PaywallAnalytics = {
    onClickOpenAccess: function(params) {
        createPaywallEvent(ACTION.openAccess, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, params));
    },
    onClickExtendSubscribe: function(params) {
        createPaywallEvent(ACTION.extendSubscribe, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, params));
    },
    onClickOpenSecurities: function() {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(PAYWALL, {
            Action: ACTION.openSecurities
        });
    },
    onClickOpenSubscribe: function() {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(PAYWALL, {
            Action: ACTION.openSubscribe
        });
    },
    onClickPaymentSelected: function(paymentMethod) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(PAYWALL, {
            Action: ACTION.paymentSelected,
            "Metode Pembayaran": PaymentMethod[paymentMethod]
        });
    },
    onClickInputVoucher: function() {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(PAYWALL, {
            Action: ACTION.inputVoucher
        });
    },
    onClickConfirmPayment: function() {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(PAYWALL, {
            Action: ACTION.confirmPayment
        });
    },
    onClickSelectPlan: function(plan) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(PAYWALL, {
            Action: ACTION.selectPlan,
            "Subscription Period": formatDuration(plan)
        });
    },
    onClickConfirmSubscribe: function() {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(PAYWALL, {
            Action: ACTION.confirmSubscribe
        });
    },
    onClickSubmitVoucher: function(voucher) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(PAYWALL, {
            Action: ACTION.submitVoucher,
            Voucher: voucher
        });
    },
    onClickSuccessSubscribe: function() {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(PAYWALL, {
            Action: ACTION.successSubscribe
        });
    }
};
/* harmony default export */ __webpack_exports__["ZP"] = (PaywallAnalytics);


/***/ }),

/***/ 29658:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var If = function(param) {
    var children = param.children, condition = param.condition;
    if (!condition) {
        return null;
    }
    // render children if the condition is truthy
    return children;
};
/* harmony default export */ __webpack_exports__["Z"] = (If); /**
 * https://www.stefanjudis.com/snippets/a-react-if-component/
 *
 * Use the component as follows:
 *
 * <IF condition={condition}>
 *   <Greeter username={user.name} />
 * </IF>
 */ 


/***/ }),

/***/ 598:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Loading_PageLoader; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Flex.js
var Flex = __webpack_require__(70821);
// EXTERNAL MODULE: ./src/global/ErrorHandlers/If.js
var If = __webpack_require__(29658);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./src/global/Loading/styled.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      opacity: 0;\n      visibility: hidden;\n      z-index: 1;\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  background: white;\n  display: flex;\n  height: 100%;\n  justify-content: center;\n  left: 0;\n  opacity: 1;\n  position: fixed;\n  top: 0;\n  transition: all 0.3s ease-in-out;\n  visibility: visible;\n  width: 100%;\n  z-index: 1050;\n\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 16px;\n  height: 16px;\n  background-color: #333;\n  margin: 0 5px;\n  border-radius: 100%;\n  display: inline-block;\n  -webkit-animation: sk-bouncedelay 1.4s infinite ease-in-out both;\n  animation: sk-bouncedelay 1.4s infinite ease-in-out both;\n  transform-origin: center center;\n\n  &:first-child {\n    -webkit-animation-delay: -0.32s;\n    animation-delay: -0.32s;\n  }\n\n  &:nth-child(2) {\n    -webkit-animation-delay: -0.16s;\n    animation-delay: -0.16s;\n  }\n\n  @-webkit-keyframes sk-bouncedelay {\n    0%,\n    80%,\n    100% {\n      -webkit-transform: scale(0);\n    }\n    40% {\n      -webkit-transform: scale(1);\n    }\n  }\n\n  @keyframes sk-bouncedelay {\n    0%,\n    80%,\n    100% {\n      -webkit-transform: scale(0);\n      transform: scale(0);\n    }\n    40% {\n      -webkit-transform: scale(1);\n      transform: scale(1);\n    }\n  }\n\n  @-webkit-keyframes sk-bouncedelay {\n    0%,\n    80%,\n    100% {\n      -webkit-transform: scale(0);\n    }\n    40% {\n      -webkit-transform: scale(1);\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}

var LoadingWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-372f28a1-0"
})(_templateObject1(), function(param) {
    var loaded = param.loaded;
    return loaded && (0,styled_components_browser_esm/* css */.iv)(_templateObject());
});
var Bouncer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-372f28a1-1"
})(_templateObject2());


;// CONCATENATED MODULE: ./src/global/Loading/Bouncer.tsx





var Bouncer_Bouncer = function(param) {
    var _isLoading = param.isLoading, isLoading = _isLoading === void 0 ? true : _isLoading;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
        condition: isLoading,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Bouncer, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Bouncer, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Bouncer, {})
            ]
        })
    });
};
/* harmony default export */ var Loading_Bouncer = (Bouncer_Bouncer);

;// CONCATENATED MODULE: ./src/global/Loading/PageLoader.jsx





function PageLoader(param) {
    var loaded = param.loaded;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingWrapper, {
        loaded: loaded,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading_Bouncer, {})
    });
}
PageLoader.propTypes = {
    loaded: (prop_types_default()).bool
};
PageLoader.defaultProps = {
    loaded: false
};
// always re-render (event no visual visiblity) => need memo
/* harmony default export */ var Loading_PageLoader = (/*#__PURE__*/react.memo(PageLoader));


/***/ }),

/***/ 56198:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2497);
/* harmony import */ var lib_entities_credentials__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21671);
/* harmony import */ var utils_auth__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14229);




//  Utils

function useProtectedRoute() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isLoaded = ref[0], setIsLoaded = ref[1];
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useDispatch */ .I0)();
    var isLoggedIn = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(lib_entities_credentials__WEBPACK_IMPORTED_MODULE_3__/* .selectors */ .wl).isLoggedIn;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var ref;
        var token = utils_auth__WEBPACK_IMPORTED_MODULE_4__/* ["default"].getToken */ .Z.getToken();
        if (!isLoggedIn && !(token === null || token === void 0 ? void 0 : (ref = token.accessToken) === null || ref === void 0 ? void 0 : ref.token)) {
            // @ts-ignore
            dispatch(lib_entities_credentials__WEBPACK_IMPORTED_MODULE_3__/* .effects.logout */ .Sz.logout());
            router.push("/login");
            return;
        }
        setIsLoaded(true);
    }, [
        dispatch,
        isLoggedIn,
        router
    ]);
    return {
        isLoaded: isLoaded
    };
}
/* harmony default export */ __webpack_exports__["Z"] = (useProtectedRoute);


/***/ }),

/***/ 20:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = new Promise(function (resolve, reject) {
    var url = new URL("https://storage.stockbit.com/backpack/1.0.0/static/remoteEntry.js");
    url.searchParams.set('t', Date.now());
    var __webpack_error__ = new Error();
    if(!window.remoteLoading) {
        window.remoteLoading = {};
    };

    if(window.remoteLoading["backpack"]) {
      return resolve(window.remoteLoading["backpack"])
    }

    var res, rej;
    window.remoteLoading["backpack"] = new Promise(function(rs,rj){
      res = rs;
      rej = rj;
    })

    if (typeof window["backpack"] !== 'undefined') {
      res(window["backpack"]);
      return resolve(window["backpack"]);
    }

     __webpack_require__.l(
      url.href,
      function (event) {
        if (typeof window["backpack"] !== 'undefined') {
          res(window["backpack"]);
          return resolve(window["backpack"]);
        }
        var errorType = event && (event.type === 'load' ? 'missing' : event.type);
        var realSrc = event && event.target && event.target.src;
        __webpack_error__.message =
          'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
        __webpack_error__.name = 'ScriptExternalLoadError';
        __webpack_error__.type = errorType;
        __webpack_error__.request = realSrc;
        rej(__webpack_error__);
        reject(__webpack_error__);
      },
      "backpack"
    );
  }).then(function () {
    const proxy = {
      get: backpack.get,
      init: function(shareScope, initToken) {

        const handler = {
          get(target, prop) {
            if (target[prop]) {
              Object.values(target[prop]).forEach(function(o) {
                if(o.from === '_N_E') {
                  o.loaded = 1
                }
              })
            }
            return target[prop]
          },
          set(target, property, value, receiver) {
            if (target[property]) {
              return target[property]
            }
            target[property] = value
            return true
          }
        }
        try {
          backpack.init(new Proxy(shareScope, handler), initToken)
        } catch (e) {

        }
        backpack.__initialized = true
      }
    }
    if (!backpack.__initialized) {
      proxy.init(__webpack_require__.S.default)
    }
    return proxy
  });

/***/ }),

/***/ 17172:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = new Promise(function (resolve, reject) {
    var url = new URL("https://storage.stockbit.com/buy-sell/1.5.4/static/remoteEntry.js");
    url.searchParams.set('t', Date.now());
    var __webpack_error__ = new Error();
    if(!window.remoteLoading) {
        window.remoteLoading = {};
    };

    if(window.remoteLoading["buysell"]) {
      return resolve(window.remoteLoading["buysell"])
    }

    var res, rej;
    window.remoteLoading["buysell"] = new Promise(function(rs,rj){
      res = rs;
      rej = rj;
    })

    if (typeof window["buysell"] !== 'undefined') {
      res(window["buysell"]);
      return resolve(window["buysell"]);
    }

     __webpack_require__.l(
      url.href,
      function (event) {
        if (typeof window["buysell"] !== 'undefined') {
          res(window["buysell"]);
          return resolve(window["buysell"]);
        }
        var errorType = event && (event.type === 'load' ? 'missing' : event.type);
        var realSrc = event && event.target && event.target.src;
        __webpack_error__.message =
          'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
        __webpack_error__.name = 'ScriptExternalLoadError';
        __webpack_error__.type = errorType;
        __webpack_error__.request = realSrc;
        rej(__webpack_error__);
        reject(__webpack_error__);
      },
      "buysell"
    );
  }).then(function () {
    const proxy = {
      get: buysell.get,
      init: function(shareScope, initToken) {

        const handler = {
          get(target, prop) {
            if (target[prop]) {
              Object.values(target[prop]).forEach(function(o) {
                if(o.from === '_N_E') {
                  o.loaded = 1
                }
              })
            }
            return target[prop]
          },
          set(target, property, value, receiver) {
            if (target[property]) {
              return target[property]
            }
            target[property] = value
            return true
          }
        }
        try {
          buysell.init(new Proxy(shareScope, handler), initToken)
        } catch (e) {

        }
        buysell.__initialized = true
      }
    }
    if (!buysell.__initialized) {
      proxy.init(__webpack_require__.S.default)
    }
    return proxy
  });

/***/ }),

/***/ 34435:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = new Promise(function (resolve, reject) {
    var url = new URL("https://storage.stockbit.com/eipo/1.1.2/static/chunks/moduleEntry.js");
    url.searchParams.set('t', Date.now());
    var __webpack_error__ = new Error();
    if(!window.remoteLoading) {
        window.remoteLoading = {};
    };

    if(window.remoteLoading["stockbitipo"]) {
      return resolve(window.remoteLoading["stockbitipo"])
    }

    var res, rej;
    window.remoteLoading["stockbitipo"] = new Promise(function(rs,rj){
      res = rs;
      rej = rj;
    })

    if (typeof window["stockbitipo"] !== 'undefined') {
      res(window["stockbitipo"]);
      return resolve(window["stockbitipo"]);
    }

     __webpack_require__.l(
      url.href,
      function (event) {
        if (typeof window["stockbitipo"] !== 'undefined') {
          res(window["stockbitipo"]);
          return resolve(window["stockbitipo"]);
        }
        var errorType = event && (event.type === 'load' ? 'missing' : event.type);
        var realSrc = event && event.target && event.target.src;
        __webpack_error__.message =
          'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
        __webpack_error__.name = 'ScriptExternalLoadError';
        __webpack_error__.type = errorType;
        __webpack_error__.request = realSrc;
        rej(__webpack_error__);
        reject(__webpack_error__);
      },
      "stockbitipo"
    );
  }).then(function () {
    const proxy = {
      get: stockbitipo.get,
      init: function(shareScope, initToken) {

        const handler = {
          get(target, prop) {
            if (target[prop]) {
              Object.values(target[prop]).forEach(function(o) {
                if(o.from === '_N_E') {
                  o.loaded = 1
                }
              })
            }
            return target[prop]
          },
          set(target, property, value, receiver) {
            if (target[property]) {
              return target[property]
            }
            target[property] = value
            return true
          }
        }
        try {
          stockbitipo.init(new Proxy(shareScope, handler), initToken)
        } catch (e) {

        }
        stockbitipo.__initialized = true
      }
    }
    if (!stockbitipo.__initialized) {
      proxy.init(__webpack_require__.S.default)
    }
    return proxy
  });

/***/ }),

/***/ 94673:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = new Promise(function (resolve, reject) {
    var url = new URL("https://storage.stockbit.com/fast-trade/1.1.6/static/remoteEntry.js");
    url.searchParams.set('t', Date.now());
    var __webpack_error__ = new Error();
    if(!window.remoteLoading) {
        window.remoteLoading = {};
    };

    if(window.remoteLoading["fasttrade"]) {
      return resolve(window.remoteLoading["fasttrade"])
    }

    var res, rej;
    window.remoteLoading["fasttrade"] = new Promise(function(rs,rj){
      res = rs;
      rej = rj;
    })

    if (typeof window["fasttrade"] !== 'undefined') {
      res(window["fasttrade"]);
      return resolve(window["fasttrade"]);
    }

     __webpack_require__.l(
      url.href,
      function (event) {
        if (typeof window["fasttrade"] !== 'undefined') {
          res(window["fasttrade"]);
          return resolve(window["fasttrade"]);
        }
        var errorType = event && (event.type === 'load' ? 'missing' : event.type);
        var realSrc = event && event.target && event.target.src;
        __webpack_error__.message =
          'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
        __webpack_error__.name = 'ScriptExternalLoadError';
        __webpack_error__.type = errorType;
        __webpack_error__.request = realSrc;
        rej(__webpack_error__);
        reject(__webpack_error__);
      },
      "fasttrade"
    );
  }).then(function () {
    const proxy = {
      get: fasttrade.get,
      init: function(shareScope, initToken) {

        const handler = {
          get(target, prop) {
            if (target[prop]) {
              Object.values(target[prop]).forEach(function(o) {
                if(o.from === '_N_E') {
                  o.loaded = 1
                }
              })
            }
            return target[prop]
          },
          set(target, property, value, receiver) {
            if (target[property]) {
              return target[property]
            }
            target[property] = value
            return true
          }
        }
        try {
          fasttrade.init(new Proxy(shareScope, handler), initToken)
        } catch (e) {

        }
        fasttrade.__initialized = true
      }
    }
    if (!fasttrade.__initialized) {
      proxy.init(__webpack_require__.S.default)
    }
    return proxy
  });

/***/ }),

/***/ 2680:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = new Promise(function (resolve, reject) {
    var url = new URL("https://storage.stockbit.com/movers/1.0.2/static/remoteEntry.js");
    url.searchParams.set('t', Date.now());
    var __webpack_error__ = new Error();
    if(!window.remoteLoading) {
        window.remoteLoading = {};
    };

    if(window.remoteLoading["movers"]) {
      return resolve(window.remoteLoading["movers"])
    }

    var res, rej;
    window.remoteLoading["movers"] = new Promise(function(rs,rj){
      res = rs;
      rej = rj;
    })

    if (typeof window["movers"] !== 'undefined') {
      res(window["movers"]);
      return resolve(window["movers"]);
    }

     __webpack_require__.l(
      url.href,
      function (event) {
        if (typeof window["movers"] !== 'undefined') {
          res(window["movers"]);
          return resolve(window["movers"]);
        }
        var errorType = event && (event.type === 'load' ? 'missing' : event.type);
        var realSrc = event && event.target && event.target.src;
        __webpack_error__.message =
          'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
        __webpack_error__.name = 'ScriptExternalLoadError';
        __webpack_error__.type = errorType;
        __webpack_error__.request = realSrc;
        rej(__webpack_error__);
        reject(__webpack_error__);
      },
      "movers"
    );
  }).then(function () {
    const proxy = {
      get: movers.get,
      init: function(shareScope, initToken) {

        const handler = {
          get(target, prop) {
            if (target[prop]) {
              Object.values(target[prop]).forEach(function(o) {
                if(o.from === '_N_E') {
                  o.loaded = 1
                }
              })
            }
            return target[prop]
          },
          set(target, property, value, receiver) {
            if (target[property]) {
              return target[property]
            }
            target[property] = value
            return true
          }
        }
        try {
          movers.init(new Proxy(shareScope, handler), initToken)
        } catch (e) {

        }
        movers.__initialized = true
      }
    }
    if (!movers.__initialized) {
      proxy.init(__webpack_require__.S.default)
    }
    return proxy
  });

/***/ }),

/***/ 85611:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = new Promise(function (resolve, reject) {
    var url = new URL("https://storage.stockbit.com/top-stocks/1.0.1/static/remoteEntry.js");
    url.searchParams.set('t', Date.now());
    var __webpack_error__ = new Error();
    if(!window.remoteLoading) {
        window.remoteLoading = {};
    };

    if(window.remoteLoading["topstocks"]) {
      return resolve(window.remoteLoading["topstocks"])
    }

    var res, rej;
    window.remoteLoading["topstocks"] = new Promise(function(rs,rj){
      res = rs;
      rej = rj;
    })

    if (typeof window["topstocks"] !== 'undefined') {
      res(window["topstocks"]);
      return resolve(window["topstocks"]);
    }

     __webpack_require__.l(
      url.href,
      function (event) {
        if (typeof window["topstocks"] !== 'undefined') {
          res(window["topstocks"]);
          return resolve(window["topstocks"]);
        }
        var errorType = event && (event.type === 'load' ? 'missing' : event.type);
        var realSrc = event && event.target && event.target.src;
        __webpack_error__.message =
          'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
        __webpack_error__.name = 'ScriptExternalLoadError';
        __webpack_error__.type = errorType;
        __webpack_error__.request = realSrc;
        rej(__webpack_error__);
        reject(__webpack_error__);
      },
      "topstocks"
    );
  }).then(function () {
    const proxy = {
      get: topstocks.get,
      init: function(shareScope, initToken) {

        const handler = {
          get(target, prop) {
            if (target[prop]) {
              Object.values(target[prop]).forEach(function(o) {
                if(o.from === '_N_E') {
                  o.loaded = 1
                }
              })
            }
            return target[prop]
          },
          set(target, property, value, receiver) {
            if (target[property]) {
              return target[property]
            }
            target[property] = value
            return true
          }
        }
        try {
          topstocks.init(new Proxy(shareScope, handler), initToken)
        } catch (e) {

        }
        topstocks.__initialized = true
      }
    }
    if (!topstocks.__initialized) {
      proxy.init(__webpack_require__.S.default)
    }
    return proxy
  });

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [74885,63332,25287,94119,78656,71577,75819,46819,7648,25935,51225,80129,80737,40142,77549,91036,54253,54005,33070,44098,44912,81273,21671,74768,12786,77284,68429,49774,92888,40179], function() { return __webpack_exec__(98652); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);